import type { SanityPageBuilderProductDownloadsTableSection, SanityPageBuilderSection } from "@ouster/shared";
import { SanityDownloads } from "~/features/downloads";
import { adaptProductsNew } from "~/features/downloads/products-adapter";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderProductDownloadsTableSection;
  };
};
export function SanityProductDownloadsTableSection({
  section
}: Props) {
  const view = adaptProductsNew(section.sectionContent.productsNewData);
  return <SanityDownloads view={view} />;
}